import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'user/EmptyUO', method: 'GET', body: null, token: token })
}
